import React from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

// Import benefit images
import benefit1 from '../assets/images/benefits/1.jpg';
import benefit2 from '../assets/images/benefits/2.jpg';
import benefit3 from '../assets/images/benefits/3.jpg';
import benefit4 from '../assets/images/benefits/4.jpg';
import benefit5 from '../assets/images/benefits/5.jpg';
import benefit6 from '../assets/images/benefits/6.jpg';

const BenifitsOfPartnership = () => {
  const benefits = [
    {
      id: 1,
      title: 'Partner in Shaping the Conversation',
      description: 'Be more than a sponsor — sit alongside senior CXOs in steering the dialogue that sets cybersecurity and technology priorities across industries.',
      image: benefit1
    },
    {
      id: 2,
      title: 'Access the Decision-Makers Who Matter',
      description: 'Connect directly with CISOs, CIOs, CTOs, and CDOs - the executives who control budgets and make enterprise technology and cybersecurity purchasing decisions.',
      image: benefit2
    },
    {
      id: 3,
      title: 'Claim a Thought Leadership Platform',
      description: 'Showcase your expertise through roundtables, panels, and exclusive knowledge exchanges that put your brand voice in front of senior decision-markers',
      image: benefit3
    },
    {
      id: 4,
      title: 'Gain Insider Perspectives',
      description: 'Access direct intelligence on how top executives are approaching emerging threats and opportunities, sharpening your market positioning and go-to-market strategies',
      image: benefit4
    },
    {
      id: 5,
      title: 'Co-create Industry Impact',
      description: 'Collaborate with leading CISOs and CXOs on thought leadership projects, strategic initiatives, and industry-shaping programs that extend your influence',
      image: benefit5
    },
    {
      id: 6,
      title: 'Accelerate Enterprise Pipelines',
      description: 'Engage directly with senior decision-makers, shortening sales cycles by building relationships in a trust-first environment.',
      image: benefit6
    }
  ];

  return (
    <section className="bg-white py-3 py-lg-5">
      <Container>
        <div className="agenda-intro text-start mb-3 mb-lg-5">
          <h2 className="benefits-title mb-3 mb-lg-5 text-center">The Benefits of Partnership</h2>

          {/* <div className="d-flex text-start">
            <ol className="ps-0 text-start benefits-list">
              <li className="mb-2">
                <p>Partner in Shaping the Conversation:</p>
                <p>Be more than a sponsor — sit alongside senior CXOs in steering the dialogue that sets cybersecurity and
                technology priorities across industries.</p>
              </li>
              <li className="mb-2">
                <p>Access the Decision-Makers Who Matter:</p>
                <p>Connect directly with CISOs, CIOs, CTOs, and CDOs - the executives who control budgets and make
                enterprise technology and cybersecurity purchasing decisions.</p>
              </li>
              <li className="mb-2">
                <p>Claim a Thought Leadership Platform:</p>
                <p>Showcase your expertise through roundtables, panels, and exclusive knowledge exchanges that put your
                brand voice in front of senior decision-markers</p>
              </li>
              <li className="mb-2">
                <p>Gain Insider Perspectives:</p>
                <p>Access direct intelligence on how top executives are approaching emerging threats and opportunities,
                sharpening your market positioning and go-to-market strategies</p>
              </li>
              <li className="mb-2">
                <p>Co-create Industry Impact:</p>
                <p>Collaborate with leading CISOs and CXOs on thought leadership projects, strategic initiatives, and
                industry-shaping programs that extend your influence</p>
              </li>
              <li className="mb-2">
                <p>Accelerate Enterprise Pipelines:</p>
                <p>Engage directly with senior decision-makers, shortening sales cycles by building relationships in a
                trust-first environment.</p>
              </li>
            </ol>
          </div> */}

          <Row>
            {benefits.map((benefit) => (
              <Col lg={4} md={6} className="mb-4" key={benefit.id}>
                <div className="benefit-box">
                  <div className="benefit-content">
                    <h5 className="fw-bold">{benefit.title}</h5>
                    <p>{benefit.description}</p>
                  </div>
                  <div>
                    <img 
                      src={benefit.image} 
                      alt={`Benefit ${benefit.id}`} 
                    />
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default BenifitsOfPartnership;
